





































import MNotification from "@/mixins/MNotification.vue";
import { sparePartRequestService } from "@/services/sparepart-request.service";
import { FormModel } from "ant-design-vue";
import { Component, Mixins, Prop, Ref } from "vue-property-decorator";

@Component({})
export default class RejectSrfModal extends Mixins(MNotification) {
  @Prop({ type: Boolean, required: true })
  visible!: boolean;

  @Prop({ type: String, required: true })
  srfId!: string;

  @Prop({ type: String, required: true })
  documentNo!: string;

  @Ref("formModel")
  formModel!: FormModel;

  formData = {
    reason: "",
  };

  formRules = {
    reason: [
      {
        required: true,
        message: this.$t("lbl_validation_required_error"),
      },
      {
        whitespace: true,
        message: this.$t("lbl_validation_required_error"),
      },
    ],
  };

  loading = false;

  handleCancel(): void {
    this.$emit("close");
  }

  rejectSrf(): void {
    this.loading = true;
    sparePartRequestService
      .reject(this.srfId, { rejectReason: this.formData.reason })
      .then(() => {
        this.showNotifSuccess("notif_reject_success", {
          documentNumber: this.documentNo,
        });
        this.$emit("onReject");
        this.$emit("close");
      })
      .catch(() => {
        this.showNotifError("notif_process_fail");
      })
      .finally(() => {
        this.loading = false;
      });
  }

  handleSubmit(): void {
    this.formModel.validate((valid: boolean) => {
      if (!valid) return;

      this.rejectSrf();
    });
  }
}
